import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Medias({ t, lang }) {

  const [photoImage, setPhotoImage] = useState(null);
  const [perfImage, setPerfImage] = useState(null);
  
    useEffect(() => {
      fetch("/api/admin/assets/images.php")
        .then(res => res.json())
        .then(data => {
          const photo = data.find(item => item.name === "box_photo_cover");
          const perf = data.find(item => item.name === "box_performances_cover");
          setPhotoImage(photo);
          setPerfImage(perf);
        })
        .catch(err => {
          console.error("Erreur chargement about", err);
        });
    }, []);

  return (
    <section id="projects">
            <div className="projects-column">
              <Link className="project-wrapper" to='/medias/portfolio'>
                  <div
                    className="project-card"
                    style={{ backgroundImage: `url(${photoImage?.image})`}}
                  >
                    <div className="project-overlay">

                      <h3
                        className="display-4"
                        style={{ fontFamily: "pangram-sans-semiBold" }}
                      >
                        {t("photos").toUpperCase()}
                      </h3>
                    </div>
                  </div>
              </Link>
              <Link className="project-wrapper" to='/medias/performances'>
                  <div
                    className="project-card"
                    style={{ backgroundImage: `url(${perfImage?.image})`}}
                  >
                    <div className="project-overlay">

                      <h3
                        className="display-4"
                        style={{ fontFamily: "pangram-sans-semiBold" }}
                      >
                        {t("performances").toUpperCase()}
                      </h3>
                    </div>
                  </div>
              </Link>
            </div>
    </section>
  );
}